import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={31}
    height={23}
    viewBox="0 0 31 23"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M29.73 16.228h-14.1a4.997 4.997 0 0 0-5.9-3.9 5.01 5.01 0 0 0-3.9 3.9h-4.1c-.55 0-1 .45-1 1s.45 1 1 1h4.1a4.996 4.996 0 0 0 5.9 3.9c1.96-.4 3.5-1.94 3.9-3.9h14.1c.55 0 1-.45 1-1s-.45-1-1-1Zm-19 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3Zm-9-14h14.1a4.996 4.996 0 0 0 5.9 3.9c1.96-.4 3.5-1.94 3.9-3.9h4.1c.55 0 1-.45 1-1s-.45-1-1-1h-4.1a4.997 4.997 0 0 0-5.9-3.9 5.01 5.01 0 0 0-3.9 3.9H1.73c-.55 0-1 .45-1 1s.45 1 1 1Zm19-4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3Z"
    />
  </Svg>
);
export default SvgComponent;
